var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChaticon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 45,
    viewBox: "0 0 48 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3438 15.0641H31.4688C31.4688 15.9235 30.7656 16.6266 29.9062 16.6266C29.0469 16.6266 28.3438 15.9219 28.3438 15.0641Z",
    fill: "#0055C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9375 12.6875C37.3594 12.6875 37.7188 13.0469 37.7188 13.4688C37.7188 13.8906 37.3594 14.25 36.9375 14.25C36.5156 14.25 36.1562 13.8906 36.1562 13.4688C36.1562 13.0469 36.5156 12.6875 36.9375 12.6875Z",
    fill: "#0055C3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.875 12.6875C23.2969 12.6875 23.6562 13.0469 23.6562 13.4688C23.6562 13.8906 23.2969 14.25 22.875 14.25C22.4531 14.25 22.0938 13.8906 22.0938 13.4688C22.0938 13.0469 22.4531 12.6875 22.875 12.6875Z",
    fill: "#0055C3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.25 30.6875V32.25C32.25 34.8437 30.1562 36.9375 27.5625 36.9375H11.9375L7.25 43.1875V36.9375H5.6875C3.09375 36.9375 1 34.8437 1 32.25V16.625C1 14.0328 3.09375 11.9375 5.6875 11.9375H10.375",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.375 27.5625L40.0625 33.8125V27.5625H41.625C44.2187 27.5625 46.3125 25.4687 46.3125 22.875V5.6875C46.3125 3.09531 44.2187 1 41.625 1H18.1875C15.5938 1 13.5 3.09531 13.5 5.6875V22.875C13.5 25.4687 15.5938 27.5625 18.1875 27.5625H35.375Z",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3438 15.0641H31.4688C31.4688 15.9235 30.7656 16.6266 29.9062 16.6266C29.0469 16.6266 28.3438 15.9219 28.3438 15.0641Z",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9375 12.6875C37.3594 12.6875 37.7188 13.0469 37.7188 13.4688C37.7188 13.8906 37.3594 14.25 36.9375 14.25C36.5156 14.25 36.1562 13.8906 36.1562 13.4688C36.1562 13.0469 36.5156 12.6875 36.9375 12.6875Z",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.875 12.6875C23.2969 12.6875 23.6562 13.0469 23.6562 13.4688C23.6562 13.8906 23.2969 14.25 22.875 14.25C22.4531 14.25 22.0938 13.8906 22.0938 13.4688C22.0938 13.0469 22.4531 12.6875 22.875 12.6875Z",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.25 30.6875V32.25C32.25 34.8437 30.1562 36.9375 27.5625 36.9375H11.9375L7.25 43.1875V36.9375H5.6875C3.09375 36.9375 1 34.8437 1 32.25V16.625C1 14.0328 3.09375 11.9375 5.6875 11.9375H10.375",
    stroke: "#0055C3",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M35.375 27.5625L40.0625 33.8125V27.5625H41.625C44.2187 27.5625 46.3125 25.4687 46.3125 22.875V5.6875C46.3125 3.09531 44.2187 1 41.625 1H18.1875C15.5938 1 13.5 3.09531 13.5 5.6875V22.875C13.5 25.4687 15.5938 27.5625 18.1875 27.5625H35.375Z",
    stroke: "#0055C3",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3438 15.0641H31.4688C31.4688 15.9235 30.7656 16.6266 29.9062 16.6266C29.0469 16.6266 28.3438 15.9219 28.3438 15.0641Z",
    stroke: "#0055C3",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9375 12.6875C37.3594 12.6875 37.7188 13.0469 37.7188 13.4688C37.7188 13.8906 37.3594 14.25 36.9375 14.25C36.5156 14.25 36.1562 13.8906 36.1562 13.4688C36.1562 13.0469 36.5156 12.6875 36.9375 12.6875Z",
    stroke: "#0055C3",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.875 12.6875C23.2969 12.6875 23.6562 13.0469 23.6562 13.4688C23.6562 13.8906 23.2969 14.25 22.875 14.25C22.4531 14.25 22.0938 13.8906 22.0938 13.4688C22.0938 13.0469 22.4531 12.6875 22.875 12.6875Z",
    stroke: "#0055C3",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChaticon);
export default __webpack_public_path__ + "static/media/chat icon.a1f78715109ed459730514046559d068.svg";
export { ForwardRef as ReactComponent };